import React from 'react';
import './confirm_box.less';

class ConfirmBox extends React.Component{
  constructor(props){
    super(props);
    this.closePopup = this.closePopup.bind(this);
    this.executeCallback = this.executeCallback.bind(this);
  }

  closePopup(e){
    e.preventDefault();
    e.stopPropagation();
    this.props.closePopupCallback();

  }

  executeCallback(e){
    e.preventDefault();
    e.stopPropagation();
    this.props.closePopupCallback();
    this.props.onConfirmCallback();
  }


  render(){
    const {props} = this;
    const self = this;
    let confirmModalClass;
    (this.props.popupState) ? (confirmModalClass = 'confirm-modal-wrap active') : (confirmModalClass = 'confirm-modal-wrap in-active');
    return(
      <div className={confirmModalClass}>
        <div className="overlay">
          <div className="confirm-modal">
              <div className="icon"></div>
              <div className="modal-header">{props.header}</div>
              <div className="modal-description">{props.description}</div>
              <div className="modal-button-wrap">
                <button className="btn orange modal-btn" onClick={this.closePopup}>Cancel</button>
                <button className="btn green modal-btn" onClick={this.executeCallback} >Ok</button>
              </div>
          </div>
        </div>
      </div>
    )
  }
}

React.propTypes ={
  popupState: React.PropTypes.bool.isRequired,
  closePopupCallback: React.PropTypes.func.isRequired,
  onConfirmCallback: React.PropTypes.func.isRequired,
  header: React.PropTypes.string.isRequired,
  description: React.PropTypes.string.isRequired
}

export default ConfirmBox;



// WEBPACK FOOTER //
// app/components/confirm_box/confirm_box.jsx